document
    .querySelectorAll('.menu-item-has-children > a')
    .forEach((item) => {
        item.addEventListener('click', (e) => {
            if (!(e.target instanceof HTMLElement)) {
                return;
            }
            if (!e.target.classList.contains('submenu-icon')) {
                return;
            }
            if (item.nextElementSibling === null || e.target === null) {
                return;
            }

            e.preventDefault();

            toggleOpenCloseMenuItem(item.nextElementSibling, e.target);
        });
    });

// Open menu item if on current page
document
    .querySelectorAll('.nav-mobile .current-menu-ancestor > a')
    .forEach((item) => {
        const submenuIcon = item.querySelector(':scope > .submenu-icon');
        if (item.nextElementSibling === null || submenuIcon === null) {
            return;
        }
        toggleOpenCloseMenuItem(item.nextElementSibling, submenuIcon)
    });

function toggleOpenCloseMenuItem(submenu, target) {
    $(submenu).slideToggle(200);

    if (target.classList.contains('fa-chevron-up')) {
        target.classList.replace('fa-chevron-up', 'fa-chevron-down');
    } else {
        target.classList.replace('fa-chevron-down', 'fa-chevron-up');
    }
}

$(() => {
    $('.filtering_opts .filter').on('click', function (event) {
        event.preventDefault();
        const href = $(this).attr("href");
        const filter = href.split("=");
        filterMap(filter);

        $('.filtering_opts .filter').removeClass("active");
        if (!$(this).hasClass("reset")) {
            $(this).addClass("active");
        }
        $('#direct_search_field option.default').attr('selected', 'selected');
    });
    $('.puffMenu .filter a').on('click', function (event) {
        event.preventDefault();
        const href = $(this).attr("href");
        const filter = href.split("=");


        filterMap(filter);


        $('.filtering_opts .filter').removeClass("active");


        $('.filtering_opts .filter.' + filter[1]).addClass("active");
        $('#direct_search_field option.default').attr('selected', 'selected');
        scrollDown();
    });


    function filterMap(filter) {
        $('.loadingContainer').show();

        // alert(templateDir);
        $('.search_holder').load(templateDir + "dealer_locator_search_result.php", { "filter": filter[1] }, function () {
            // $("#direct_search_field").empty();
            // $("#direct_search_field").append($('.search_holder .fieldsWrapper #direct_search option'));
            $("#direct_search_field option[value='0']").prop('selected', true);
            setTimeout(function () {
                $('.loadingContainer').hide();
            }, 500);
        });
        $('.results_holder').load(templateDir + "dealer_locator_loop.php", { "filter": filter[1] });


    }


    $("#subject").val($(".placeholder").val());

    $('#toggle_navigation').on('click', function () {
        $(this).toggleClass('open');
        $('.nav-mobile').fadeToggle(400);
    });
    $(".toggle_navigation").on('click', function () {
        $('.navigation ul').toggleClass('open');
        $('.toggle_navigation').toggleClass('hide');
    });


    // $(".toggle_search").on('click', function() {
    //  $('.search').toggleClass('open');
    //  $('.toggle_search').toggleClass('hide');
    //  $('.search-input').focus();
    // });




    $(".select_continent").on('change', function () {


        function getPathFromUrl(url) {
            return url.split("?")[0];
        }


        var url = getPathFromUrl(window.location.href);


        console.log($(this).val());
        window.location.href = url + '?changeContinent=' + $(this).val();
        // $('.search').toggleClass('open');
        // $('.toggle_search').toggleClass('hide');
        // $('.search-input').focus();
    });


    $(".select_continent").on('change', function () {


        function getPathFromUrl(url) {
            return url.split("?")[0];
        }


        var url = getPathFromUrl(window.location.href);

        window.location.href = url + '?changeContinent=' + $(this).val();
    });




    $(".select_option").on('click', function () {


        if ($(this).hasClass('selected')) {


            $('.desktop_select').slideToggle(200);


        } else {


            function getPathFromUrl(url) {
                return url.split("?")[0];
            }


            var url = getPathFromUrl(window.location.href);

            window.location.href = url + '?changeContinent=' + $(this).attr('data-value');
        }

    });


    $(".desktop_select_trigger").on('click', function () {
        $('.desktop_select').slideToggle(200);
    });


    //NAVIGATION


    $(".grow").on('click', function () {


        if ($(this).html() == '<i class="fa fa-chevron-right"></i>') {
            $(this).html('<i class="fa fa-chevron-down"></i>');
            $(this).parent("li").children(".sub-menu").slideToggle(300);
        } else {
            $(this).html('<i class="fa fa-chevron-right"></i>');
            $(this).parent("li").children(".sub-menu").slideToggle(300);
        }


    });


    $('.current-menu-item').children(".grow").html('<i class="fa fa-chevron-down"></i>');
    $('.current-menu-ancestor').children(".grow").html('<i class="fa fa-chevron-down"></i>');


});
function scrollDown() {
    $('html, body').animate({ scrollTop: $($("#dealersection")).offset().top }, 700, "swing");
}


$(document).on('change', '#subject', function () {
    var reg = $(this).children("option:selected").val();


    $(".recievers").each(function () {
        $(this).children("option").first().attr("selected", "selected");
        $(this).hide();
        $(this).attr("name", "");
    })
    $("#" + reg + "Select").show();
    $("#" + reg + "Select").attr("name", "reciever");


});


$(document).on('submit', '#contactForm', function () {
    var name = $("#name").val();
    var email = $("#email").val();
    var url = $("#urlsender").val();
    var subject = $("select[name=reciever] :selected").text();
    var reciever = $("select[name=reciever] :selected").val();
    var message = $("#message").val();
    var contactForm = $("#contactForm").attr("name");
    if (name != "" && isValidEmailAddress(email) && reciever != "Subject" && message != "") {
        $.post("new_sender.php", { contactForm: contactForm, name: name, email: email, subject: subject, reciever: reciever, message: message, url: url },
            function (data) {
                $('#contactForm')[0].reset();
                $(".confirmationDiv").slideDown();
                setTimeout(function () { $(".confirmationDiv").slideUp(); }, 5000);
            }).fail(function () {
                alert("Something went wrong. Please try again in a while.");
            });
    } else {
        alert("Make sure to fill out all fields and enter a valid email adress.");
    }


    return false;
})


function isValidEmailAddress(emailAddress) {
    var pattern = new RegExp(/^(("[\w-+\s]+")|([\w-+]+(?:\.[\w-+]+)*)|("[\w-+\s]+")([\w-+]+(?:\.[\w-+]+)*))(@((?:[\w-+]+\.)*\w[\w-+]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][\d]\.|1[\d]{2}\.|[\d]{1,2}\.))((25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\.){2}(25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\]?$)/i);
    return pattern.test(emailAddress);
};

